import { useState } from "react";
import { IUser } from "../../../types/user";

interface UsersProps {
  users: IUser[];
  selectedUserId: number;
  onSelectUser: (idUser: number) => void;
}

const SelectUsers = ({ users, selectedUserId, onSelectUser }: UsersProps) => {

  const [selected, setSelected] = useState(selectedUserId);

  const onHandleConfirm = () => {
    // console.log('onHandleConfirm', selected)
    onSelectUser(selected);
  };

  const onChangeSelect = (value: string) => {
    // console.log('Atendente selecionado', value)
    setSelected(Number(value))
  };

  return (
    <div className="pb-2">
      <h5 className="font-size-11 text-uppercase mb-2">Transferir Atendente :</h5>
      <div>
        <div className="d-flex align-items-end">
          <div className="flex-grow-1">
            <p className="text-muted font-size-14 mb-1">Atendente</p>
          </div>
        </div>

        <div className="d-flex align-items-end gap-2">
          <div className="flex-grow-1">
            <select
              value={selected}
              className="form-select form-select-sm"
              onChange={(e) => onChangeSelect(e.target.value)}
            >
              <option value="0">Desatribuir conversa</option>

              {(users || []).map((opt: IUser) => (
                <option key={opt.id} value={opt.id}>
                  {opt.name}
                </option>
              ))}
            </select>
          </div>
          {/* <div className="flex-shrink-0"> */}
          <button type="button" className="btn btn-sm btn-soft-primary" onClick={onHandleConfirm}>
            Confirmar
          </button>
          {/* </div> */}
        </div>


      </div>

      {/* <div className="mt-4">
        <p className="text-muted font-size-14 mb-1">Endereço</p>
        <h5 className="font-size-14">
          {chatUserDetails.address ? chatUserDetails.address : "-"}
        </h5>
      </div> */}

    </div>

  );
};

export default SelectUsers;
